export default __webpack_public_path__ + "static/testtowebm-6cda9971650fbc402db49e23dad6998a.webm";